<template>
  <div>
    <div id="relatoer" class="container mt-3">
      <div class="text-center mb-3">
        <span style="font-size: larger;">Relatórios</span>
      </div>

      <div class="row g-3">
        <div class="col-12 col-sm-6" v-for="item in relatorios" :key="item.id">
          <li class="list-group-item list-group-item-action border rounded p-0"
              @click.prevent="mtdabrirtela(item.tela)">
            <div class="card h-100" style="background-color: #212529;">
              <div class="container py-3">
                <div class="row">
                  <div class="col-2 text-center d-flex align-items-center justify-content-center">
                    <i :class="item.icone" style="font-size: 30px;"></i>
                  </div>
                  <div class="col-10">
                    <span class="tit-item-menu-ve d-block text-white">{{ item.titulo }}</span>
                    <small class="sub-tit-item-menu-ve text-muted d-block">{{ item.subtitulo }}</small>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </div>
      </div>
    </div>

    <div id="conteudorel" class="container mt-4">
      <div v-if="relreceitasdespesas">
        <relreceitasdespview />
      </div>
      <div v-if="reldespesascommetas">
        <reldespesascommetasview />
      </div>
      <div v-if="reldemonstrativolancamento">
        <reldemonstrativolancamentoview />
      </div>
      <div v-if="relgraficoevolucao">
        <relgraficoevolucaoview />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import relreceitasdespview from './relatorios/relreceitasdesp.vue'
import reldespesascommetasview from './relatorios/reldespesascommetas.vue'
import reldemonstrativolancamentoview from './relatorios/reldemonstrativolancamento.vue'
import relgraficoevolucaoview from './relatorios/relgraficoevolucao.vue'

export default {
  name: 'relatoer',
  components: {
    relreceitasdespview,
    reldespesascommetasview,
    reldemonstrativolancamentoview,
    relgraficoevolucaoview
  },
  data() {
    return {
      relreceitasdespesas: false,
      reldespesascommetas: false,
      reldemonstrativolancamento: false,
      relgraficoevolucao: false,
      relatorios: [
        {
          id: 1,
          titulo: 'Gráfico despesas/receitas',
          subtitulo: 'Balanço geral entre suas receitas e despesas',
          icone: 'bi bi-pie-chart-fill',
          tela: 'relreceitasdespesas'
        },
        {
          id: 2,
          titulo: 'Despesas com metas',
          subtitulo: 'Mostra os lançamentos vinculados às metas',
          icone: 'bi bi-rocket-takeoff-fill',
          tela: 'reldespesascommetas'
        },
        {
          id: 3,
          titulo: 'Lançamentos detalhados',
          subtitulo: 'Todos os movimentos financeiros por período',
          icone: 'bi bi-kanban-fill',
          tela: 'reldemonstrativolancamento'
        },
        {
          id: 4,
          titulo: 'Gráfico de evolução',
          subtitulo: 'Evolução financeira anual (EM BREVE)',
          icone: 'bi bi-reception-3',
          tela: 'relgraficoevolucao'
        }
      ]
    }
  },
  methods: {
    mtdabrirtela(tela) {
      $('#relatoer').hide();
      this.fechatelas();

      if (tela === 'relgraficoevolucao') {
        alert('Este relatório será disponibilizado em breve 😊');
        $('#conteudorel').hide();
        $('#relatoer').fadeIn(700);
        return;
      }

      this[tela] = true;
      $('#conteudorel').fadeIn(700);
    },
    fechatelas() {
      this.relreceitasdespesas = false;
      this.reldespesascommetas = false;
      this.reldemonstrativolancamento = false;
      this.relgraficoevolucao = false;
    }
  }
}
</script>

<style scoped>
.sub-tit-item-menu-ve {
  font-size: 0.75rem;
}

.tit-item-menu-ve {
  font-weight: 600;
  color: white;
}

@media (max-width: 576px) {
  .tit-item-menu-ve {
    font-size: 0.9rem;
  }
  .sub-tit-item-menu-ve {
    font-size: 0.65rem;
  }
}
</style>
